if (!customElements.get('collection-drawer')) {

    customElements.define(
        'collection-drawer',
        class CollectionDrawer extends DetailsModal {
            constructor() {
                super();
                this.closeButton = this.querySelector('.collection-drawer__close-button');
                this.closeButton?.addEventListener('click', this.close.bind(this));
            }

            onSummaryClick(event) {
                super.onSummaryClick(event);
                setTimeout(() => {
                    this.detailsContainer.classList.add('menu-opening');
                });
            }

            close(focusToggle = true) {
                let animationStart;
                this.detailsContainer.classList.remove('menu-opening');
                this.detailsContainer.querySelector('summary').setAttribute('aria-expanded', false);
                removeTrapFocus(focusToggle ? this.summaryToggle : null);
                document.body.removeEventListener('click', this.onBodyClickEvent);
                document.body.classList.remove('overflow-hidden');
                const handleAnimation = (time) => {
                    if (animationStart === undefined) {
                        animationStart = time;
                    }

                    const elapsedTime = time - animationStart;

                    if (elapsedTime < 400) {
                        window.requestAnimationFrame(handleAnimation);
                    } else {
                        this.detailsContainer.removeAttribute('open');
                        if (this.detailsContainer.closest('details[open]')) {
                            trapFocus(this.detailsContainer.closest('details[open]'), this.detailsContainer.querySelector('summary'));
                        }
                    }
                };

                window.requestAnimationFrame(handleAnimation);
            }
        }
    );
}